import React, { useCallback, useContext, useEffect, useState } from 'react';
import { MplServiceClientFactory } from '../../api/MplServiceClientFactory';
import constants from '../../common/constants';
import { WorkflowTableIdentity } from '../../common/CookieRegistry';
import arraySort from 'array-sort';
import Breadcrumbs from '../common/Breadcrumbs';
import {
  ContentAudienceCol,
  ContentIdCol,
  ContentSubTypeCol,
  IsLockedCol,
  LastPublicationDateCol,
  PostContentNameCol,
  ProgressCol,
  RankCol,
  TechWriterOwnerCol,
  UpdatedDateCol,
  WorkflowTagsCol,
} from '../workflow-viewer/ContentWorkflowColumnDefinitions';
import ContentWorkflowTable from '../workflow-viewer/ContentWorkflowTable';
import { WorkflowActions } from '../../model/Enum';
import { postFilter } from '../../api/ContentUtil';
import { Box } from '@amzn/awsui-components-core';

const mplService = MplServiceClientFactory.create();

const ManagePosts = () => {
  const columnDefinition = [
    ContentIdCol,
    TechWriterOwnerCol,
    ContentSubTypeCol,
    ContentAudienceCol,
    PostContentNameCol,
    UpdatedDateCol,
    RankCol,
    LastPublicationDateCol,
    ProgressCol,
    IsLockedCol,
    WorkflowTagsCol,
  ];

  const allowedControlActions = [
    WorkflowActions.EDIT_WORKFLOW,
    WorkflowActions.DELETE_WORKFLOW,
    WorkflowActions.DEMOTE_AUDIENCE,
    WorkflowActions.UNLOCK_WORKFLOW,
  ];

  const [isLoading, setIsLoading] = useState(false);
  const [allPosts, setAllPosts] = useState([]);

  const fetchPosts = useCallback(async () => {
    setIsLoading(true);
    try {
      const { workflows } = await mplService.getAllPosts();
      const postWorkflows = postFilter(workflows);
      arraySort(postWorkflows, 'lastDraftUpdate', { reverse: true });
      // @ts-expect-error TS2345 - strict migration
      setAllPosts(postWorkflows);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchPosts();
  }, [fetchPosts]);

  const breadcrumbItems = [
    { text: constants.APP_NAME_BREAD_CRUMB, href: '/' },
    { text: constants.MANAGE_POSTS, href: '' },
  ];

  return (
    <div>
      <Breadcrumbs items={breadcrumbItems} />
      <Box padding={{ top: 'm' }}>
        <ContentWorkflowTable
          tableId={WorkflowTableIdentity.ManagePosts}
          header={constants.MANAGE_POSTS}
          loading={isLoading}
          workflows={allPosts}
          columnDefinitions={columnDefinition}
          onRefreshClick={fetchPosts}
          allowedControlActions={allowedControlActions}
        />
      </Box>
    </div>
  );
};

export default ManagePosts;
